<template>
  <div id="popupModal" class="popup-modal">
    <v-overlay :dark="false">
      <v-card min-width="400px">
        <div class="d-flex justify-space-between align-center pr-2">
          <img v-if="isAlert || isConfirm" class="popup-img" :src="imgUrl" />
          <v-card-title class="text-h6 font-weight-bold">
            {{ title }}
          </v-card-title>
          <v-btn icon @click="hide(cancelCallback)"><v-icon>fa-close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <div v-if="isAlert || isConfirm" class="content">
            <div v-if="text">{{ text }}</div>
            <div v-if="isConfirm && askShowAgain">
              <v-checkbox
                label="Do not show me it again"
                name="showAgain"
                id="showAgain"
                v-model="dontShowAgain" />
            </div>
          </div>
          <div v-else>
            <v-text-field
              outlined
              :label="inputName"
              dense
              hide-details
              clearable
              v-virtual-keyboard
              v-model="input">
            </v-text-field>

            <div v-if="extendedInputName" style="width: 100%">
              <br />
              <span class="popup-input-name">{{ extendedInputName }}</span>
              <v-textarea
                hide-details
                outlined
                v-virtual-keyboard
                type="text"
                v-model="extendedInput"></v-textarea>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="!isAlert" color="red" elevation="0" text @click="hide(cancelCallback)">
            {{ isAlert ? 'Close' : isConfirm ? 'No' : 'Cancel' }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" v-if="!isAlert" @click="ok()" color="primary">
            {{ isConfirm ? 'Yes' : 'Ok' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
  import warning from '../../images/warning.png';
  import confirm from '../../images/confirm.png';
  import $ from 'jquery';
  export default {
    name: 'MessagePopup',
    data() {
      return {
        title: '',
        text: '',
        isAlert: false,
        isConfirm: false,
        askShowAgain: false,
        dontShowAgain: false,
        input: '',
        inputName: '',
        extendedInput: '',
        extendedInputName: '',
        callback: null,
        cancelCallback: null,
      };
    },
    methods: {
      /*
            { 
                title, 
                text, 
                isConfirm,
                askShowAgain,
                cancelCallback,
                isAlert,
                callback
                input : {
                    inputName,
                    inputValue
                }
            }

        */
      show({ title, text, isConfirm, askShowAgain, cancelCallback, isAlert, callback, input }) {
        this.title = title;
        this.text = text;
        this.isAlert = isAlert;
        this.isConfirm = isConfirm;
        this.askShowAgain = askShowAgain;
        this.callback = callback;
        this.cancelCallback = cancelCallback;
        if (input) {
          this.inputName = input.inputName;
          this.input = input.inputValue;
        }
        $('#popupModal').css('display', 'flex');
      },
      showExtendedInput({
        title,
        text,
        isConfirm,
        askShowAgain,
        isAlert,
        callback,
        input,
        extendedInput,
      }) {
        this.title = title;
        this.text = text;
        this.isAlert = isAlert;
        this.isConfirm = isConfirm;
        this.askShowAgain = askShowAgain;
        this.callback = callback;
        if (input) {
          this.inputName = input.inputName;
          this.input = input.inputValue;
        }
        if (extendedInput) {
          this.extendedInputName = extendedInput.inputName;
          this.extendedInput = extendedInput.inputValue;
        }
        $('#popupModal').css('display', 'flex');
      },
      hide(callback = null) {
        $('#popupModal').css('display', 'none');
        this.extendedInputName = '';
        this.input = '';

        if (callback) callback({ dontShowAgain: this.dontShowAgain });

        this.cancelCallback = null;
        this.askShowAgain = false;
        this.dontShowAgain = false;
      },
      ok() {
        if (!this.isConfirm && !this.input) {
          //in case of prompt
          alert('Invalid input.');
          return;
        }
        var callbackParameter = '';
        if (this.isConfirm) {
          callbackParameter = true;
        } else if (this.extendedInputName) {
          if (!this.extendedInput) {
            alert('Invalid input.');
            return;
          }
          callbackParameter = [this.input, this.extendedInput];
          this.extendedInputName = '';
        } else {
          callbackParameter = this.input;
        }

        this.hide();
        this.callback(callbackParameter, this.dontShowAgain);
      },
    },
    computed: {
      imgUrl: function () {
        let result = this.isAlert ? warning : this.isConfirm ? confirm : '';
        return result;
      },
    },
  };
</script>

<style>
  .popup-modal {
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 9999;
  }

  .popup-img {
    width: 20px;
    height: auto;
  }
</style>
